import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { getCustomerList, addCustomerIds } from '@/request';
import { getVexTableProps } from '@/config';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddCustomerModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    },
    custType: {
      type: [String, Number],
      default: ''
    },
    activityId: {
      type: [String, Number],
      default: ''
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const keyWord = ref('');
    const table = ref();
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '客户名称',
        field: 'custName',
        width: '150px',
        overflow: true
      }, {
        title: '客户区域',
        field: 'territories',
        width: '150px',
        overflow: true
      }, {
        title: '客户类型',
        field: 'dictitemName',
        overflow: true
      }, {
        title: '详细所在地',
        field: 'address'
      }],
      pagerConfig: {
        pageSize: 5
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getCustomerList({
              page: page.currentPage,
              rows: page.pageSize,
              id: props.id,
              supplierBranchOnly: 1,
              needToFilterBranchUserId: props.id,
              custType: props.custType,
              moduleType: '20',
              readFromBackup: '1',
              uri: 'com.ylsk.web.admin.coupon.domain.CouponCustomer_addCustomerCk',
              keyWord: keyWord.value
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      } // const ids = selectRows.map((item) => item.erpId).join(',');


      selectRows.forEach(item => item.erpCustId = item.erpId);
      visible.value = false;
      emit('success', selectRows); // addCustomerIds({
      //   customerIds: ids,
      //   activityId: props.id,
      //   changeErpIds: ids,
      //   type: props.custType,
      //   moduleType: 20,
      //   readFromBackup: 1,
      //   __warn: true,
      //   __repeat: true
      // }).then((data) => {
      //   if (data.success) {
      //     visible.value = false;
      //     emit('success', selectRows);
      //   }
      // });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择客户",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "700px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: keyWord.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyWord.value = $event),
              placeholder: "客户名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};